<template>
  <div class="award">
    <div class="contentBox" v-show="isShowInfo">
      <div class="title">{{ AwardName }}</div>
      <el-form :model="ruleForm" ref="ruleForm" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="企业工商名称(中文)"
              prop="CompanyNameCN"
              :rules="[
                {
                  required: true,
                  message: '请输入企业工商名称（中文）',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-select
                v-model="ruleForm.CompanyNameCN"
                placeholder="企业工商名称（中文）"
                :loading="loadingCompanyName"
                filterable
                default-first-option
                clearable
                remote
                reserve-keyword
                :remote-method="remoteMethod"
                @change="handleActName"
              >
                <el-option
                  v-for="item in CompanyList"
                  :key="item.companyName"
                  :label="item.companyName"
                  :value="item.creditNo"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业工商名称(英文)" prop="CompanyNameEN">
              <el-input
                v-model="ruleForm.CompanyNameEN"
                placeholder="企业工商名称（英文）"
                maxlength="200"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="联系人手机"
              prop="PhoneNumber"
              :rules="[
                {
                  required: true,
                  message: '请输入正确的手机号',
                  trigger: 'blur',
                },
                { pattern: /^1\d{10}$/, message: '请输入正确的手机号' },
              ]"
            >
              <el-input
                v-model="ruleForm.PhoneNumber"
                placeholder="联系人手机"
                maxlength="11"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="推荐机构"
              prop="RecommendInstitution"
              :rules="[
                {
                  required: true,
                  message: '请选择推荐机构',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="ruleForm.RecommendInstitution"
                placeholder="推荐机构"
                clearable
              >
                <el-option
                  v-for="item in RecommendInstitutionList"
                  :label="item.InstitutionName"
                  :value="item.InstitutionName"
                  :key="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item
              prop="SMSCode"
              :rules="[
                { required: true, message: '请输入验证码', trigger: 'blur' },
              ]"
            >
              <div class="codeBox">
                <div class="divCode" style="width: 200px">
                  <el-input
                    v-model="ruleForm.SMSCode"
                    placeholder="验证码"
                    maxlength="6"
                    clearable
                    @blur="searchAwardInfo"
                  ></el-input>
                </div>
                <div class="divCode">
                  <el-button :disabled="disabled" @click="getCode">
                    <span class="Time">{{ btnTxt }}</span>
                  </el-button>
                </div>
                <div class="divCode" style="color: #f56c6c">
                  验证码有效期24小时，请勿随意删除
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="联系人姓名"
              prop="ContactName"
              :rules="[
                {
                  required: true,
                  message: '请输入联系人姓名',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="ruleForm.ContactName"
                placeholder="联系人姓名"
                maxlength="200"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系人职务"
              prop="ContactJob"
              :rules="[
                {
                  required: true,
                  message: '请输入联系人职务',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="ruleForm.ContactJob"
                placeholder="联系人职务"
                maxlength="200"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人座机" prop="ContactTelephone">
              <el-input
                v-model="ruleForm.ContactTelephone"
                placeholder="联系人座机"
                maxlength="100"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系人邮箱"
              prop="ContactEmail"
              :rules="[
                {
                  required: true,
                  message: '请输入联系人邮箱',
                  trigger: 'blur',
                },
                {
                  type: 'email',
                  message: '请输入正确的邮箱地址',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="ruleForm.ContactEmail"
                placeholder="联系人邮箱"
                maxlength="200"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="所在行业"
              prop="Industry"
              :rules="[
                {
                  required: true,
                  message: '请选择所在行业',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="ruleForm.Industry"
                placeholder="所在行业"
                clearable
              >
                <el-option
                  v-for="item in IndustryList"
                  :label="item.Name"
                  :value="item.Name"
                  :key="item.Name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="总部所在地"
              prop="Location"
              :rules="[
                {
                  required: true,
                  message: '请选择总部所在地',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="ruleForm.Location"
                placeholder="总部所在地"
                clearable
              >
                <el-option
                  v-for="item in LocationList"
                  :label="item.Name"
                  :value="item.Name"
                  :key="item.Name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="员工人数"
              prop="EmployeeNum"
              :rules="[
                {
                  required: true,
                  message: '请选择员工人数',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="ruleForm.EmployeeNum"
                placeholder="员工人数"
                clearable
              >
                <el-option
                  v-for="item in EmployeeNumList"
                  :label="item.Name"
                  :value="item.Name"
                  :key="item.Name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="成立时间"
              prop="EstablishDate"
              :rules="[
                {
                  required: true,
                  message: '请选择成立时间',
                  trigger: 'change',
                },
              ]"
            >
              <el-date-picker
                v-model="ruleForm.EstablishDate"
                type="year"
                placeholder="选择成立时间"
                clearable
              ></el-date-picker>
              <!-- <el-input placeholder="成立时间"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              prop="LogoAttachments"
              label="LOGO文件"
              :rules="[
                { required: true, message: '请上传LOGO文件', trigger: 'blur' },
              ]"
            >
              <div class="fileFlex">
                <UploadPan
                  ref="upload2"
                  v-model="fileList2"
                  :form="form"
                  class="editor-upload-btn"
                  :model="model"
                  @on-close="handleCloseUpload2"
                  @on-update="handleOnUpdate2"
                  :accept="accept2"
                  color="#1890ff"
                />
                <span class="spanRemark"
                  >请上传企业logo源文件，如ai，psd，png等，以便后期制作获奖证书等相关文件使用。</span
                >
              </div>
              <ul v-show="ruleForm.LogoAttachments" class="listFile">
                <li
                  v-for="(fileItem, index) in ruleForm.LogoAttachments"
                  :key="index"
                >
                  <div class="div1">{{ fileItem.name }}</div>
                  <div class="div2" @click="removeItem(fileItem.url)">删除</div>
                </li>
              </ul>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              prop="CompanyDescription"
              label="企业介绍"
              :rules="[
                {
                  required: true,
                  message: '请输入企业介绍，不超过300字',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                v-model="ruleForm.CompanyDescription"
                placeholder="请输入企业介绍，不超过300字"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="remark">
              注：<br />
              请审慎填写以上信息，其中<span>企业名称、logo、团队名称、项目名称、个人奖项报名者姓名及title将用于后续宣传、奖杯、奖状制作，请核实、确认之后进行填写</span>；<br />
              如有任何问题，请邮件联系
              <a href="mailto:awards@hroot.cn">awards@hroot.cn</a
              >，由于申报企业数量较多，在您发送邮件时请统一邮件主题，样式为：企业名称+申报奖项；<br />
              报名截止日期为2024年6月28日下午5:00。
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              prop="AwardTypeIds"
              label="申报奖项"
              :rules="[
                {
                  required: true,
                  message: '请选择申报奖项',
                  trigger: 'change',
                },
              ]"
            >
              <strong>请选择您要申报的奖项（最多2个）</strong>
              <el-checkbox-group
                v-model="ruleForm.AwardTypeIds"
                :max="2"
                @change="handleChecked"
              >
                <el-checkbox
                  v-for="item in awardTypeList"
                  :key="item.Id"
                  :label="item.Id"
                  >{{ item.Name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <template v-if="selectedAwardTypes.length > 0">
              <div
                class="awardsList"
                v-for="item in selectedAwardTypes"
                :key="item.Id"
              >
                <strong class="awardItemName">{{ item.Name }}</strong>
                <ul class="awardsUl">
                  <li>
                    <el-button type="primary" @click="getAwardReportUrl(item)"
                      >点击下载</el-button
                    >
                    提名表，并按要求填写及上传；
                  </li>
                  <li>
                    其他补充材料（如有），包括项目结案报告、方案、证书、图片等信息，佐证填写内容，并以附件的形式上传。<br />
                    <strong
                      >注：请审慎填写以上信息，其中<span>企业名称、logo、团队名称、项目名称、个人奖项报名者姓名及title将用于后续宣传、奖杯、奖状制作，请核实、确认之后进行填写</span>。</strong
                    >
                  </li>
                </ul>
              </div>
            </template>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item class="btnClass">
              <el-button
                :disabled="submitDisabled"
                @click="clickSave('ruleForm', 1)"
                type="primary"
                v-prevent-re-click
                >提交</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="noPage" v-show="isNotFound">找不到页面</div>
    <el-dialog
      title="资料提交提示"
      :visible.sync="dialogVisible"
      width="50%"
      center
      :close-on-click-modal="false"
    >
      <div class="sussDiv">
        <div class="sussOne">
          <img src="../../assets//successs.svg" alt="" /> 资料提交成功
        </div>
        <div class="sussTwo">
          稍后组委会将发送短信或邮件给您，若未收到任何信息，<br />请及时联系177
          2119 7808或021-58215197-8020
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="重复提交提示"
      :visible.sync="dialogRepeatVisible"
      width="50%"
      center
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="sussDiv">
        <div class="sussThree">
          您好，系统显示贵司已经申报过2024HRoot卓越大奖，请内部核查申报人信息或联系组委会177
          2119 7808、021-58215197-8020进行核查
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadPan from '@/components/Upload/index'
import { v4 as uuidv4 } from 'uuid'
import {
  getSlyFuzzySearchList,
  getSmsCode,
  getAwardNameByEncryptId,
  getApplyAwardTypeListByAwardId,
  getEmployeeNumRange,
  getIndustryList,
  getProvinceList,
  getInstitutionList,
  AddOrUpdAwardApplication,
  getAwardApplicationInfo,
  getAwardReportUrl,
  submitSendnotice,
  addVueLog,
} from '../../api/api'

export default {
  data() {
    return {
      monitoring: {}, // 日志
      submitDisabled: false,
      dialogRepeatVisible: false, // 重复提交的弹窗
      fileList2: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept2: '*',
      UploadApi: `${process.env.VUE_APP_BASE_API}/api/AwardApplication/upload`,
      logoList: [],
      isNotFound: false,
      isShowInfo: false, // 是否显示页面
      AwardName: '', // 标题名称
      loadingCompanyName: false, // 适用活动 加载效果
      CompanyList: [], // 公司列表
      ruleForm: {
        AwardId: 0,
        EncryptAwardId: this.$route.params.id, // 页面传入的ID,
        CompanyNameCN: '',
        CompanyNameEN: '',
        SCC: '',
        PhoneNumber: '',
        SMSCode: '',
        SMSType: 'award',
        cacheTime: '600',
        ContactName: '',
        ContactJob: '',
        ContactTelephone: '',
        ContactEmail: '',
        Industry: '',
        Location: '',
        EmployeeNum: '',
        EstablishDate: '',
        RecommendInstitution: '',
        LogoAttachments: [],
        CompanyDescription: '',
        AwardTypeIds: [], // 选择的奖项ID
        AwardAttachments: [],
        Status: 0, // 草稿 = 1,待修改 = 2,未审核 = 3,待终审 = 4,通过 = 5
      },
      selectedAwardTypes: [],
      EmployeeNumList: [], // 员工人数
      IndustryList: [], // 企业性质
      LocationList: [], // 总部所在地
      RecommendInstitutionList: [], // 推荐机构
      btnTxt: '获取验证码',
      disabled: false, // 是否禁用  即点击之后一段时间内无法再点击
      awardTypeList: [], // 奖项类型列表
      selectAwardId: '',
      dialogVisible: false, // 提交后的提示
    }
  },
  components: {
    UploadPan,
  },
  methods: {
    handleCloseUpload2() {
      this.fileList2 = []
    },
    handleOnUpdate2(obj) {
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      let attachment = {
        url: url,
        name: obj.ResTitle,
        ContentType: obj.ContentType,
        Type: 1,
        AwardTypeId: 0,
      }
      this.ruleForm.LogoAttachments.push(attachment)
    },

    // 提交
    clickSave(formName, status) {
      let that = this
      that.ruleForm.Status = status
      if (this.ruleForm.Status !== 1) {
        this.$message({
          message: '此页面信息不可修改，请进入补录页面进行信息补录！',
          type: 'warning',
        })
        return false
      }
      // if(!(this.ruleForm.Status==0||this.ruleForm.Status==1)){
      //   this.$message({
      //     message: '此页面信息不可修改，请勿继续操作！',
      //     type: 'warning',
      //   })
      //   return false
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitDisabled = true
          AddOrUpdAwardApplication(this.ruleForm).then((res) => {
            console.log('res', res)
            if (res.data.success) {
              let sendnotice = {
                Id: res.data.response,
                SignName: 'HRoot',
                TemplateCode: 'SMS_465675201',
                Remark: '',
              }
              submitSendnotice(sendnotice).then((res) => {
                console.log('sms res', res)
              })
              // this.$router.push({ path: '/success' }) // 强制切换当前路由 path
              this.dialogVisible = true
            } else {
              this.submitDisabled = false
              this.$message({
                message: res.data.msg,
                type: 'warning',
              })
            }
          })
        } else {
          return false
        }
      })
    },

    // 奖项类型选择事件
    handleChecked(val) {
      this.selectedAwardTypes = this.awardTypeList.filter((a) =>
        val.includes(a.Id)
      )
    },

    searchAwardInfo(val) {
      const SMSCode = this.ruleForm.SMSCode
      const SCC = this.ruleForm.SCC
      const phone = this.ruleForm.PhoneNumber
      const companyName = this.ruleForm.CompanyNameCN
      let awardInfo = {
        EncryptAwardId: this.ruleForm.EncryptAwardId,
        SCC: SCC,
        PhoneNumber: this.ruleForm.PhoneNumber,
        SMSCode: SMSCode,
        SMSType: this.ruleForm.SMSType,
      }
      getAwardApplicationInfo(awardInfo).then((res) => {
        console.log('res', res)
        if (res.data.success) {
          if (res.data.response.Status == 3) {
            this.$message({
              message: '此页面信息不可修改，请进入补录页面进行信息补录！',
              type: 'warning',
            })
            // setTimeout(() => {
            //   this.$router.push({path: "/awardFillin/1"}); // 强制切换当前路由 path
            // }, 5000);
            return false
          }
          if (
            !(res.data.response.Status == 0 || res.data.response.Status == 1)
          ) {
            this.$message({
              message: '此页面信息不可修改，请勿继续操作！',
              type: 'warning',
            })
            return false
          }
          this.ruleForm = res.data.response
          this.ruleForm.SMSType = 'award'
          this.ruleForm.SMSCode = SMSCode
          this.selectedAwardTypes = this.awardTypeList.filter((a) =>
            this.ruleForm.AwardTypeIds.includes(a.Id)
          )
          this.ruleForm.PhoneNumber = phone
          this.ruleForm.CompanyNameCN = companyName
          this.ruleForm.SCC = SCC

          this.ruleForm.EncryptAwardId = this.$route.params.id
        } else {
          if (res.data.msg == '重复提交') {
            this.dialogRepeatVisible = true
            this.submitDisabled = true
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning',
            })
          }
        }
      })
    },

    // 企业名称
    remoteMethod(query) {
      if (query !== '') {
        this.loadingCompanyName = true
        let debItem = null
        if (debItem) {
          clearTimeout(debItem)
        }

        debItem = setTimeout(() => {
          getSlyFuzzySearchList(query).then((res) => {
            if (res.data.success) {
              const data = res.data.response.data.data

              this.CompanyList = data.map((item) => {
                return {
                  companyName: item.companyName,
                  creditNo: !item.creditNo ? uuidv4() : item.creditNo,
                }
              })
              this.loadingCompanyName = false
            }
          })
        }, 500)
      }
    },
    // 企业名称 选择事件，获取选择数据的值
    handleActName(val) {
      this.ruleForm.SCC = val
      this.ruleForm.CompanyNameCN = val
        ? this.CompanyList.find((ele) => ele.creditNo === val).companyName
        : ''
    },

    // 获取验证码
    getCode() {
      // 校验手机号码
      if (!this.ruleForm.PhoneNumber) {
        //号码校验不通过
        this.$message({
          message: '请输入手机号',
          type: 'warning',
        })
        //正则判断 从1开始，第二位是35789中的任意一位，以9数字结尾
      } else if (!/^1\d{10}$/.test(this.ruleForm.PhoneNumber)) {
        // 失去焦点后自动触发校验手机号规则
      } else {
        this.time = 60
        this.disabled = true

        //调用倒计时方法
        getSmsCode({
          type: this.ruleForm.SMSType,
          phoneNumber: this.ruleForm.PhoneNumber,
          cacheTime: this.ruleForm.cacheTime,
        }).then((res) => {
          console.log('res time', res)
          if (res.data.success) {
            this.$message({
              message: '验证码发送成功',
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning',
            })
          }
        })
      }
    },
    // 获取奖项列表
    getApplyAwardTypeListByAwardId() {
      getApplyAwardTypeListByAwardId({
        EnctyptAwardId: this.$route.params.id,
      }).then((res) => {
        if (res.data.success) {
          this.awardTypeList = res.data.response
        }
      })
    },
    // 获取员工数量范围
    getEmployeeNumRange() {
      getEmployeeNumRange().then((res) => {
        if (res.data.success) {
          this.EmployeeNumList = res.data.response
        }
      })
    },
    // 获取所属行业列表
    getIndustryList() {
      getIndustryList().then((res) => {
        if (res.data.success) {
          this.IndustryList = res.data.response
        }
      })
    },
    // 获取城市列表
    getProvinceList() {
      getProvinceList().then((res) => {
        if (res.data.success) {
          this.LocationList = res.data.response
        }
      })
    },
    // 推荐机构列表
    getInstitutionList() {
      getInstitutionList().then((res) => {
        if (res.data.success) {
          this.RecommendInstitutionList = res.data.response
        }
      })
    },

    // 删除附件
    removeItem(url) {
      this.ruleForm.LogoAttachments = this.ruleForm.LogoAttachments.filter(
        (item) => item.url != url
      )
      this.$forceUpdate()
    },
    // 生成 EDM 文件
    getAwardReportUrl(item) {
      var params = {
        awardId: item.AwardId,
        awardTypeId: item.Id,
      }
      getAwardReportUrl(params).then((res) => {
        if (res.data.success) {
          const url = res.data.response
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', url.substring(url.lastIndexOf('/') + 1))
          link.target = '_blank' // 针对 ie模式 的浏览器
          link.click()
        }
      })
    },

    // 添加判断方法
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      console.log(flag)
      return flag
    },
    postVueLog(params) {
      addVueLog(params).then((res) => {
        if (res.data.success) {
        }
      })
    },
  },
  mounted() {
    //监听鼠标点击事件
    window.addEventListener('mouseup', (event) => {
      console.log('mouseup')
      console.log(event.target.innerText)
      if (event.target.innerText == '提交') {
        const params = {
          title: '用户点击',
          data: JSON.stringify(this.ruleForm),
          page: window.location.href,
        }
        this.postVueLog(params)
      }
    })
    //监听报错信息
    window.addEventListener('error', (err) => {
      const params = {
        title: 'error',
        data: err.message,
        page: window.location.href,
      }
      this.postVueLog(params)
    })
    // 判断传入的参数是否正确
    getAwardNameByEncryptId(this.ruleForm.EncryptAwardId).then((res) => {
      if (res.data.success) {
        this.AwardName = res.data.response.AwardName
        this.isShowInfo = true
      } else {
        this.isNotFound = true
      }
    })
    this.getApplyAwardTypeListByAwardId()
    this.getEmployeeNumRange()
    this.getIndustryList()
    this.getProvinceList()
    this.getInstitutionList()

    if (this.isMobile()) {
      this.$message({
        message: '请复制链接，在电脑端进行操作！',
        type: 'warning',
        duration: 10000,
      })
    }
  },
}
</script>

<style scoped>
.el-select {
  width: 100%;
}

.award {
  width: 100%;
  height: 100vh;
  position: relative;
  background: rgba(200, 200, 200, 0.1);
  overflow: auto;
}

.contentBox {
  position: relative;
  border: 0px solid #f56c6c;
  width: 1000px;
  display: block;
  margin: 0 auto;
  padding: 30px 30px;
  background-color: #fff;
  box-shadow: 0 0 20px 0 rgba(65, 67, 70, 0.1);
}

.title {
  text-align: center;
  font-size: 24px;
  line-height: 36px;
  font-weight: bold;
  padding: 0 0;
  margin: 0 0 50px;
}

.codeBox {
  display: flex;
  flex-wrap: nowrap;
}

.divCode {
  width: auto;
  margin-right: 20px;
}

.divCode:first-child {
  margin-right: 20px;
}

.remark {
  border: 1px solid #dcdfe6;
  font-size: 14px;
  line-height: 22px;
  color: #606266;
  padding: 15px;
  margin: 30px 0;
  border-radius: 4px;
  box-shadow: 0 0 20px 0 rgba(65, 67, 70, 0.1);
}

.remark span {
  font-size: 14px;
  line-height: 22px;
  color: #f56c6c;
}

.spanRemark {
  color: #606266;
  line-height: 20px;
  /* display: block; */
  text-align: left;
  margin-left: 20px;
}

.remark a {
  color: #606266;
  font-size: 16px;
}

.fileFlex {
  display: flex;
  align-items: center;
}

.fileFlex .el-upload {
  text-align: left;
}

.margFlex {
  margin-top: 15px;
}

.divLogos a {
  margin-right: 20px;
}

.awardsList {
  font-size: 14px;
  line-height: 22px;
  border: 1px solid #ccc;
  margin: 0 0 30px 130px;
  padding: 20px;
  color: #606266;
  border-radius: 4px;
  box-shadow: 0 0 20px 0 rgba(65, 67, 70, 0.1);
}

.awardsUl {
  margin: 0;
  padding: 0 0 0 20px;
}

.awardsUl span {
  color: red;
}

.fileUpload {
  margin-top: 15px;
}

.btnClass {
  text-align: center;
  color: #606266;
}

.noPage {
  text-align: center;
  font-size: 30px;
  line-height: 40px;
  padding: 100px;
}

.awardItemName {
  font-size: 18px;
  line-height: 30px;
  padding-bottom: 5px;
  display: block;
}

.sussDiv {
  text-align: center;
}

.sussDiv img {
  width: 36px;
  display: block;
  margin-right: 20px;
}

.sussOne {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  line-height: 30px;
}

.sussTwo {
  margin-top: 30px;
  font-size: 16px;
  line-height: 30px;
}

.sussThree {
  font-size: 16px;
  line-height: 30px;
}

.listFile {
  color: #555555;
  margin: 20px 0 0;
  padding: 0 0;
}

.listFile li {
  list-style-type: none;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 0 10px;
}

.listFile li:hover {
  background-color: #f5f7fa;
}

.listFile .div1 {
  flex: 1;
}

.listFile .div2 {
  width: 30px;
  cursor: pointer;
}
</style>
